import { createSelector } from 'reselect';
import getBooking from './getBooking';
import isBookingLoaded from './isBookingLoaded';

const getBookingPaxTotal = createSelector(
  isBookingLoaded,
  getBooking,
  (loaded, booking) =>
    loaded ? booking.pax[0].prices.total_booking_price : {},
);

export default getBookingPaxTotal;
